/** Colores de calificación del legacy: < 70 rojo, 70–89 amarillo, ≥ 90 verde. */
export function colorCalificacion(p: number): string {
  if (p >= 90) return 'text-verde-texto';
  if (p >= 70) return 'text-amarillo-texto';
  return 'text-rojo-texto';
}

export function mensajeCalificacion(p: number): string {
  if (p >= 90) return '¡Muy bien!';
  if (p >= 70) return 'Vas bien';
  return 'Esfuérzate más';
}

export function etiquetaCategoria(c: string): string {
  if (c === 'enarm') return 'ENARM';
  if (c === 'aleatorio') return 'Aleatorio';
  if (c === 'por-especialidad') return 'Por especialidad';
  return c;
}

/** `mm:ss` o `h:mm:ss`. */
export function reloj(segundos: number): string {
  const s = Math.max(0, Math.round(segundos));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, '0');
  return h > 0
    ? `${String(h)}:${String(m).padStart(2, '0')}:${ss}`
    : `${String(m).padStart(2, '0')}:${ss}`;
}
